// extracted by mini-css-extract-plugin
module.exports = {"Target":"Targets_Target__mbA7S","Original":"Targets_Original__3uZHC","Active":"Targets_Active__1LHNB"};